module.exports = __webpack_public_path__ + "static/img/index2.fc096f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index2.png
// module id = lwdB
// module chunks = 2